import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './SubscriptionStatus.css';

export default function SubscriptionStatus({ mode }) {
  const { search } = useLocation();
  const ok = new URLSearchParams(search).get('ok') !== '0';

  const copy = mode === 'unsubscribed'
    ? {
      icon: ok ? '✓' : '✕',
      title: ok ? "You're unsubscribed" : 'That link has expired',
      body: ok
        ? "You won't get any more emails from The PP Studio. If that was a mistake, you can subscribe again any time from the homepage."
        : 'This unsubscribe link is no longer valid. If you still want to stop receiving emails, use the unsubscribe link in your most recent email.',
    }
    : {
      icon: ok ? '✓' : '✕',
      title: ok ? "You're subscribed!" : 'That link has expired',
      body: ok
        ? "You'll get an email the moment Pooja publishes something new on The PP Edit."
        : 'This confirmation link is no longer valid. Head back to the homepage and subscribe again to get a fresh one.',
    };

  return (
    <div className="sub-status-page">
      <Navbar />
      <div className="sub-status-card">
        <span className={`sub-status-icon ${ok ? 'is-ok' : 'is-error'}`}>{copy.icon}</span>
        <h1>{copy.title}</h1>
        <p>{copy.body}</p>
        <a href="/" className="sub-status-cta">Back to The PP Studio →</a>
      </div>
      <Footer />
    </div>
  );
}
